var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30228 7.86546C9.40188 7.37818 10.0981 7.37818 10.1977 7.86547C10.8088 10.855 13.145 13.1912 16.1345 13.8023C16.6218 13.9019 16.6218 14.5981 16.1345 14.6977C13.145 15.3088 10.8088 17.645 10.1977 20.6345C10.0981 21.1218 9.40188 21.1218 9.30228 20.6345C8.69125 17.645 6.35497 15.3088 3.36546 14.6977C2.87818 14.5981 2.87818 13.9019 3.36547 13.8023C6.35497 13.1912 8.69125 10.855 9.30228 7.86546Z",
    stroke: "#141414",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5954 3.02417C17.602 2.99194 17.648 2.99194 17.6546 3.02417C17.9964 4.69659 19.3034 6.00356 20.9758 6.34539C21.0081 6.35198 21.0081 6.39802 20.9758 6.40461C19.3034 6.74644 17.9964 8.05341 17.6546 9.72583C17.648 9.75806 17.602 9.75806 17.5954 9.72583C17.2536 8.05341 15.9466 6.74644 14.2742 6.40461C14.2419 6.39802 14.2419 6.35198 14.2742 6.34539C15.9466 6.00356 17.2536 4.69659 17.5954 3.02417Z",
    stroke: "#141414",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationSummary);
export default __webpack_public_path__ + "static/media/conversation_summary.6881cbc11383f088c8cb54f3e735b725.svg";
export { ForwardRef as ReactComponent };